import { useRef } from "react";

/** An uncertain request retries with the same key; changed inputs get a new key. */
export function useIdempotencyKey() {
  const tracker = useRef<ReturnType<typeof createIdempotencyTracker> | null>(
    null,
  );
  if (!tracker.current) tracker.current = createIdempotencyTracker();
  return tracker.current;
}

export function createIdempotencyTracker() {
  let current: { fingerprint: string; key: string } | null = null;
  return {
    forPayload(payload: unknown) {
      const fingerprint = JSON.stringify(payload);
      if (current?.fingerprint !== fingerprint) {
        current = { fingerprint, key: crypto.randomUUID() };
      }
      return current!.key;
    },
    reset() {
      current = null;
    },
  };
}
